<template>
<div id="reporte_pedimentos_manifestacion" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="Reportes de Manifestación de Valor
" class="elevation-1 px-5 py-3" >
          <br>
          <v-tabs grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab :key="'in-view'" >Vista Previa</v-tab>
            <v-tab :key="'in-report'" >Generar en Reporte</v-tab>

            <v-tab-item :key="'in-view'" >
              <v-card-text>
                <v-card-title>
                  <span class="headline" ></span>
                </v-card-title>
                <v-form ref="form1" lazy-validation>
                  <v-container grid-list-md text-xs-center>
                    <v-row row wrap>
                      <v-col sm="4" md="4" lg="4" >
                        <v-autocomplete v-model="model.tipo_busqueda" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Busqueda" @change="clear_values()" :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-col>                      
                      <v-col sm="2" v-if="model.tipo_busqueda!=3" >
                        <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                          <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>                      
                    </v-row>                    

                    <v-row v-if="model.tipo_busqueda!=1" row wrap>
                      <v-col sm="12" md="6" lg="6" >
                        <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Pago Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" :rules="model.tipo_busqueda==1?[validaAnio, validaFecha, validaDias]:[rules.required, validaAnio, validaFecha, validaDias]" v-mask="'####-##-##'" >
                            </v-text-field>
                          </template>

                          <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu3 = false" >
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu3 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col sm="12" md="6" lg="6" >
                        <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Pago Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" :rules="model.tipo_busqueda==1?[validaAnio, validaFecha, validaDias]:[rules.required, validaAnio, validaFecha, validaDias]" v-mask="'####-##-##'" >
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu4 = false" >
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu4 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>

                      </v-col>
                    </v-row>
                    <v-row v-if="model.tipo_busqueda!=3" row wrap>
                      <v-col>
                        Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                      </v-col>
                    </v-row>
                    <v-row v-if="model.tipo_busqueda!=3" row wrap>
                      <v-col sm="12" md="12" lg="12" >
                        <v-combobox v-model="lista_filtrada" label="Lista de archivos" multiple persistent-hint small-chips disabled color="green" >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn rounded color="success" @click="get_data_view()" :loading="loading" >
                  <v-icon>done</v-icon>Vista Previa
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-client-table ref="vuetable" :data="data_view.datos" :columns="data_view.columns" :options="data_view.options" class="elevation-2 pa-2 scroll-table" >
                  <template slot="noResults" >
                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                  </template>


                  <template slot="valor_comercial" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.valor_comercial, 4)}}
                    </div>
                  </template>
                  <template slot="fletes" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.fletes, 4)}}
                    </div>
                  </template>
                  <template slot="seguros" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.seguros, 4)}}
                    </div>
                  </template>
                  <template slot="embalajes" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.embalajes, 4)}}
                    </div>
                  </template>
                  <template slot="incrementables" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.incrementables, 4)}}
                    </div>
                  </template>
                  <template slot="total_incrementables" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.total_incrementables, 4)}}
                    </div>
                  </template>
                  <template slot="valor_aduana" slot-scope="props" >
                    <div class="text-number" >
                      {{formatNumber(props.row.valor_aduana, 4)}}
                    </div>
                  </template>

                </v-client-table>
              </v-card-text>
            </v-tab-item>
            <v-tab-item :key="'in-report'" >
              <v-card-text>
                <v-card-title>
                  <span class="headline" ></span>
                </v-card-title>
                <v-form ref="form" lazy-validation>
                  <v-container grid-list-md text-xs-center>
                    <v-row row wrap>
                      <v-col sm="6" md="6" lg="6" >
                        <v-autocomplete v-model="model.tipo_reporte" :items="list_tipo_reportes" :hide-no-data="true" :return-object="false" item-text="tipo" item-value="valor" label="Tipo de Reporte" >
                        </v-autocomplete>
                      </v-col>
                      <v-col sm="4" md="4" lg="4" >
                        <v-autocomplete v-model="model.tipo_busqueda" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Búsqueda" @change="clear_values()" :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-col>                      
                      <v-col v-if="model.tipo_busqueda!=3" sm="2" >
                        <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                          <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>                      
                    </v-row>
                    
                    <v-row v-if="model.tipo_busqueda!=1" row wrap>
                      <v-col sm="12" md="6" lg="6" >
                        <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Pago Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" :rules="model.tipo_busqueda==1?[validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]:[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" v-mask="'####-##-##'" >
                            </v-text-field>
                          </template>

                          <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu1 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col sm="12" md="6" lg="6" >
                        <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }" >
                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Pago Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" :rules="model.tipo_busqueda==1?[validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]:[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" v-mask="'####-##-##'" >
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu2 = false" >
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>

                      </v-col>
                    </v-row>
                    <v-row v-if="model.tipo_busqueda!=3" row wrap>
                      <v-col>
                        Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                      </v-col>
                    </v-row>
                    <v-row v-if="model.tipo_busqueda!=3" row wrap>
                      <v-col sm="12" md="12" lg="12" >
                        <v-combobox v-model="lista_filtrada" label="Lista de archivos" multiple persistent-hint small-chips disabled color="green" >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn rounded color="success" @click="generar_reporte_sqs" :loading="loading" >
                  <v-icon>done</v-icon>Generar Reporte
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-refresh-button :funcion="cargar" />

                <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                  <template slot="noResults" >
                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                  </template>

                  <template slot="actions" slot-scope="props" >
                    <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                      <v-icon dark>get_app</v-icon>
                    </v-btn>
                    <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                </v-client-table>
              </v-card-text>
            </v-tab-item>
          </v-tabs>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
  <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="" >
          <small><b>Consulta máxima de 50 pedimentos</b></small>
          <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="model.lista='';dialog1 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="setListValues();" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
  created: function() {
    this.URL = this.$hostname + "reportes/";
    this.loading = false;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario")
        this.permisoEliminar = true;
    var userSubtipo = this.$local_storage.get("subtipo_usuario","");
    if (userSubtipo != ""){ //Agente de Carga o Transportista solo puede consultar PDF Pedimento_Simplificado, y no pueden descargar
        if (userSubtipo == "agentes_de_carga" || userSubtipo == "transportistas")
          this.permisoDescarga = false;
    }
    this.cargar();
  },
  data: () => ({
    permisoEliminar: false,
    permisoDescarga: true,
    tab: null,
    lista_filtrada: [],
    dialog1: false,
    allChecked: false,
    to_download: [],
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
          text: "Vucem-Pedimento",
          disabled: true,
          to: ""
      },
      {
        text: "Reportes de Manifestación de Valor",
        disabled: true,
        to: ""
      }
    ],
    list_tipo_reportes: [
      {"tipo": "Reporte Valor Global de Pedimento y su relación con MVe", "valor":1},
      //{"tipo": "Reporte de Valores MVe vs Pedimento", "valor":2},
      //{"tipo": "Reporte de Valores Declarados entre MVe y Pedimento", "valor":3},
    ],
    tipos: [{
      "id": 1,
      "text": "Por Número de Pedimento"
    }, {
      "id": 2,
      "text": "Por Número de Manifestación de Valor"
    },{
      "id": 3,
      "text": "Por Fechas"
    }],
    datos: [],
    columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: true,
    show_loading: true,
    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      lista: "",
      reporte_url: "/reportes_vucem/consultar_pedimentos_manifestacion/",
      nombre_reporte: "Pedimentos Manifestación",
      tipo: "Rpt Pedimentos vs Maifestación",
      tipo_reporte: 1,
      tipo_busqueda: 1,
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    data_view: {
      datos: [],
      columns: ['no_pedimento','fecha_pago','no_pedimento_original', 'fecha_original', 'fecha_entrada',
        'clave_documento','tipo_pedimento','valor_comercial',
            'fletes','seguros','embalajes','incrementables',
            'total_incrementables','valor_aduana','clave_caso','complemento_1'
      ],
      options: {
        filterable: ['no_pedimento','fecha_pago','no_pedimento_original', 'fecha_original', 'fecha_entrada',
        'clave_documento','tipo_pedimento','valor_comercial',
            'fletes','seguros','embalajes','incrementables',
            'total_incrementables','valor_aduana','clave_caso','complemento_1'],
        sortable: ['no_pedimento','fecha_pago','no_pedimento_original', 'fecha_original', 'fecha_entrada',
        'clave_documento','tipo_pedimento','valor_comercial',
            'fletes','seguros','embalajes','incrementables',
            'total_incrementables','valor_aduana','clave_caso','complemento_1'],
        headings: {
          no_pedimento: 'No Pedimento',
          fecha_pago: 'Fecha Pago Real',
          no_pedimento_original: "No Pedimento que Origina R1",
          fecha_original: 'Fecha Original',
          fecha_entrada: 'Fecha de Entrada',
          tipo_pedimento: 'Tipo Pedimento',
          clave_documento: 'Clave Documento',        
          valor_comercial: 'Valor Comercial',
          fletes: 'Fletes',
          seguros: 'Seguros',
          embalajes: 'Embalajes',
          incrementables: 'Incrementables',
          'total_incrementables':"Total Incrementables",
          'valor_aduana':"Valor Aduana",
          'clave_caso':"Clave Caso",
          'complemento_1':"Complemento 1",
          
        
        }
      }
    }
  }),
  methods: {
    validaFecha: function(fecha){
        if (fecha == "Invalid date")
            return "Fecha no válida.";
        else
          return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
        if (Math.abs(diferencia) > 31)
          return "Periodo máximo de consulta en visa previa 31 dias.";
      }
      return true;
    },
    maxListaRule: function() {
      if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
        return "Lista vacia";
      }

      let x = this.model.lista.split("\n");

      if (x.length > 50) {
        return "No se puede consultar mas de 50 lineas";
      }

      return true;
    },
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        tipo: this.model.tipo
      };
      axios.post(this.URL + "get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
            });
            for (var k in this.datos) {
              this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
              this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
              this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
              this.datos[k].criterio = this.getCriterioPredeterminados(this.datos[k].criterio);
            }
          }
        })
        .catch(err => {
          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminados: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          if (params.tipo_busqueda == 1) {
            return "Búsqueda por No. de Pedimento";
          } else if (params.tipo_busqueda == 2) {
            return "Búsqueda por No. de Manifesación, Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
          } else if (params.tipo_busqueda == 3) {
            return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
          } else {
            return "Búsqueda por lista";
          }
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }

    },
    get_data_view: function() {
      if (!this.$refs.form1.validate()) {
        //Alguna operación o mensaje
      } else {
        if ([1,2].includes(this.model.tipo_busqueda) && this.model.lista == '') {
          this.$swal({
            type: "info",
            title: "Información",
            text: "Debes ingresar al menos un elemento a la lista",
            footer: ""
          });

          return false;
        }
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;
        
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.lista == '' || data.lista == []) {
          delete(data['lista'])
        } else {
          if ([1,2].includes(this.model.tipo_busqueda)) {
            data['lista'] = this.get_array_lista(data['lista'])
          }
        }
        data["preview"] = 1;

        axios({
            method: "post",
            url: this.$apiReportes + "reportes_vucem/consultar_pedimentos_manifestacion/",
            data: data
          })
          .then(response => {
            this.to_download = [];
            this.data_view.datos = response.data;
              this.data_view.datos = this.data_view.datos.sort( ( a, b) => {
                  return new Date(a.fecha_pago) - new Date(b.fecha_pago) ;
              });
            if ([1,2].includes(this.model.tipo_busqueda)) {
              this.model.lista = '';
              this.lista_filtrada = [];
            }
          })
          .catch(error => {
            console.log(error);
            let mensaje;
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
            } else {
              mensaje = "Reporte demasiado grande para vista previa. Intenta con un periodo más corto";
            }

            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.$root.$dialogLoader.hide();
          });
      }
    },
    generar_reporte_sqs() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        if (this.model.tipo_reporte == 1){// Global
          this.model.reporte_url = "/reportes_vucem/consultar_pedimentos_manifestacion/";
          this.model.nombre_reporte = "Valor global de Pedimento y su relación con MVe";
        } else if (this.model.tipo_reporte == 2){ // MVe vs Pedimento
          this.model.reporte_url = "/reportes_vucem/pedimentos_vs_manifestacion/";
          this.model.nombre_reporte = "Valores MVe vs Pedimento";
        } else if (this.model.tipo_reporte == 3){ // Auditoria
          //ESTE REPORTE TODAVÍA NO LO DEFINE LOURDES
          this.model.reporte_url = "/reportes_vucem/auditoria_pedimentos_manifestacion/";
          this.model.nombre_reporte = "Valores Declarados entre MVe y Pedimento";
        }

        //Validaciones:
        // Si es por pedimento, no necesita las fechas
        // Si es por Manifestacion, si necesita las fechas
        // Si es por fechas, no ocupa lista

        if ([1,2].includes(this.model.tipo_busqueda) && this.model.lista == '') {
          this.$swal({
            type: "info",
            title: "Información",
            text: "Debes ingresar al menos un elemento a la lista",
            footer: ""
          });

          return false;
        }
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.lista == '' || data.lista == []) {
          delete(data['lista']);
        } else {
          if ([1,2].includes(this.model.tipo_busqueda)) {
            data['lista'] = this.get_array_lista(data['lista']);
          }
        }
        data["preview"] = 0;
        
        axios({
            method: "post",
            url: this.$hostname + "reportes/save_reporte/",
            data: data
          })
          .then(response => {
            this.to_download = [];
            if ([1,2].includes(this.model.tipo_busqueda)) {
              this.model.lista = '';
              this.lista_filtrada = [];
            }
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
                mensaje = error.response.data.mensaje;
                if (error.response.status == 406){
                    titulo = "¡Ya existe un reporte en proceso!";
                    tipo = "info";
                }
            } else {
                mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
                type: tipo,
                title: titulo,
                text: mensaje,
                footer: ""
            });
          }).then(() => {
            this.cargar();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    clear_values() {
      this.model.fecha_de = '';
      this.model.fecha_a = '';
      this.model.lista = "";
      this.lista_filtrada = [];
    },
    
    downloadReporte: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    
    setListValues: function() {
      this.lista_filtrada = [];
      let to_list = this.get_array_lista(this.model.lista);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada.push(to_list[i]);
        }
      }
      this.dialog1 = !this.dialog1;
    },
    get_array_lista: function(cadena) {
      let data = cadena != undefined ? cadena.split("\n") : "";
      let newarr = data.filter(a => a.trim() !== '');
      for (var i = 0; i < newarr.length; i++) {
        newarr[i] = newarr[i].trim();
        newarr[i] = newarr[i].replace(',', '');
        newarr[i] = newarr[i].replace('.', '');
      }

      return newarr;
    },
    formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                numero = 0;
            numero = Number(numero);
            if (isNaN(numero)){
                return "";
            } else
                return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
    eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();
                    });
              }
          });
        },
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small ;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small ;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}

.text-number {
    text-align: right;
}
</style>
